//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FloatingBack',
  props: {
    /** 浅色场景（深色背景页）用白底更亮 */
    light: {
      type: Boolean,
      default: false
    },
    iconSize: {
      type: [Number, String],
      default: 18
    },
    ariaLabel: {
      type: String,
      default: '返回'
    },
    /** 指定则始终跳转到该路径（推荐 Tab 入口页使用，避开微信 history 问题） */
    to: {
      type: String,
      default: ''
    },
    /** back 无效时的兜底路径 */
    fallback: {
      type: String,
      default: '/home'
    }
  },
  methods: {
    onClick (e) {
      if (this.$listeners.click) {
        this.$emit('click', e)
        return
      }
      this.smartBack()
    },
    navigate (path) {
      if (!path) path = '/home'
      this.$router.push({ path, query: { hideTrans: 'true' } })
    },
    smartBack () {
      if (this.to) {
        this.navigate(this.to)
        return
      }
      const start = this.$route.fullPath
      if (window.history.length > 1) {
        this.$router.back()
        setTimeout(() => {
          if (this.$route.fullPath === start) {
            this.$router.replace({ path: this.fallback || '/home', query: { hideTrans: 'true' } })
          }
        }, 180)
      } else {
        this.$router.replace({ path: this.fallback || '/home', query: { hideTrans: 'true' } })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/FloatingBack.vue